import { hash } from 'rsvp';
import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';
import ActionBookingsPriceController from 'uplisting-frontend/pods/action/bookings/price/controller';

export default abstract class SidebarBookingsPriceRoute extends PermittedRoute {
  @service('repositories/tax') taxRepository!: Services['repositories/tax'];

  @service('calendar/manager')
  calendarManager!: Services['calendar/manager'];

  @service('booking-drawer')
  bookingDrawer!: Services['booking-drawer'];

  permission = 'calendar.bookings.price';

  abstract parentRoute: string;

  model() {
    const booking = this.modelFor(this.parentRoute) as ModelRegistry['booking'];

    return hash({
      booking,
      taxes: this.taxRepository.findAll(),
    });
  }

  setupController(
    controller: ActionBookingsPriceController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, model);
  }

  resetController(
    controller: ActionBookingsPriceController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    if (this.bookingDrawer.isOpen) {
      return;
    }

    this.calendarManager.interaction.discardMoveOf(controller.booking);

    controller.booking.rollbackAttributes();

    const { price } = controller.booking;

    if (price) {
      price.rollbackAttributes();
      price.dropOrphanedExtraPrices();
    }
  }
}
